import { createSlice } from "@reduxjs/toolkit";

export const blog_tags = createSlice({
  name: "blog_tags",
  initialState: {
    value: {
      status: false,
      data: [
        { id: "1", name: "Education" },
        { id: "2", name: "Stories" },
        { id: "3", name: "Awards" },
        { id: "4", name: "Recognitions" },
        { id: "5", name: "Achievements" },
      ],
    },
  },
  reducers: {
    updateBlogTags: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
    addBlogTag: (state, action) => {
      state.value.status = true;
      state.value.data = [...state.value.data, action.payload?.tag];
    },
  },
});

export const { updateBlogTags, addBlogTag } = blog_tags.actions;

export default blog_tags.reducer;
